exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".snack__content[data-v-8a0f0256]{max-width:100vw;min-width:100vw}.title-name[data-v-8a0f0256]{font-size:17px;padding-top:10px;padding-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8a0f0256","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FeedbackMessage.vue
// module id = 6QVN
// module chunks = 0